module.exports = __webpack_public_path__ + "assets/img/guiZhouShanYangXingZhe.6e7542a9.png";